<template>
    <div class="meetinglist">

        <div class="title">
            <div class="left">
                {{ name }}
            </div>
            <div class="more" @click="showMeeting">
                查看更多 >
            </div>
        </div>

        <!-- <div class="tab_box">
            <div class="tab_item" v-for="(item, index) in tabList" :key="index" :class="TabCur == index ? 'activeTab' : '' " @click="TabClick(item, index)" >
                {{ item.name }}
            </div>
        </div> -->

        <div class="news_list">
            <div class="news_item" v-for="(item, index) in NewsList" :key="index" @click="showNewsDetail( item )"  @mouseover="hoverIndex = index" @mouseout="hoverIndex = null">
                <div :class="hoverIndex == index ? 'hvr-grow' :''  ">
                    <img :src="item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') != -1"  alt="">
                    <img :src="$ImgUrl + item.news_headpic" v-if="item.news_headpic && item.news_headpic.indexOf('http') == -1"  alt="">
                </div>
                <div class="news_title" :class="hoverIndex == index ? 'activeItem' :''  ">
                    {{ item.news_title }}
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        props: {
            name: String,
            id: Number,
        },
        data() {
            return {
                tabList: [
                    { name: "全部" },{ name: "支部委员会" },{ name: "支部委员大会" },{ name: "党小组会" },{ name: "党课" },
                ],
                TabCur: 0, 
                size: 4,
                cate_id: 10,
                NewsList: [], // 党员先锋展
                hoverIndex: null,
            }
        },
        mounted () {
            this.getNewsList();
        },
        methods: {
            // 点击tab
            TabClick ( item, index ) {
                this.TabCur = index
            },
            // 会议展示
            showMeeting () {
                this.$router.push({
                    path:"/moreNewsList",
                    query: {
                        cate_id: this.cate_id,
                        isSearch: 0,
                        keyword: ""
                    }
                })
            },
            // 获取新闻列表
            async getNewsList () {
                let { cate_id, size } = this 
                let res = await this.$axios.post("/lencon/pc/index/index_news_list", { cate_id, pageSize: size })
                if ( res.data.code == 1 ) {
                    this.NewsList = res.data.res
                }
            },

            showNewsDetail ( item ) {
                this.$router.push({
                    path: `/NewsDetail/${item.news_id}`,
                    query: {
                        cate_id: item.cate_id
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "../../assets/css/main.scss";
.activeItem {
    color: #2767c4 ;
    font-weight: bold;
}
.meetinglist {
    width: 1200px;
    margin:0 auto;
    padding: 30px;
    box-sizing: border-box;
    background-color: #fff;
    .title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-bottom: 10px;
        border-bottom: 1px solid #2767c4 ;
        .left {
            font-size: 24px;
            font-weight: bold;
            color: #2767c4 ;
        }
        .more {
            font-size: 14px;
            color: #b3b3b3;
            cursor: pointer;
        }
    }
    .tab_box {
        width: 100%;
        margin: 20px 0;
        display: flex;
        align-items: center;
        .tab_item {
            font-size: 18px;
            cursor: pointer;
            margin: 0 20px;
            font-weight: bold;
        }
        .activeTab {
            color: #2767c4 ;
        }
    }

    .news_list {
        width: 100%;
        display: flex;
        margin-top: 20px;
        justify-content: space-between;
        .news_item {
            width: 260px;
            cursor: pointer;
            img {
                width: 260px;
                height: 156px;
            }
            .news_title {
                    font-size: 16px;
                    // font-weight: bold;
                    @include MultipleRows(2);
                    margin-top: 10px;
                }
                .dept {
                    font-size: 16px;
                    color: #828181;
                    line-height: 40px;
                }
                .desc {
                    font-size: 14px;
                    color: #8e8e8e;
                    line-height: 30px;
                    span {
                        margin-right: 10px;
                    }
                }
                .status-line {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-right: 50px;
                    padding: 10px 0;
                    font-size: 14px;
                    border-top: 1px solid #ebeaea;
                    border-bottom: 1px solid #ebeaea;
                    .status_left {
                        color: #2767c4 ;
                    }
                    .show_info {
                        color: #8e8e8e;
                    }
                }
        }
        
    }
}
</style>